<template>
<div id="nissan-quiz-nowifi-ipad" class="nissan-quiz-screen">

</div>
</template>

<script>
export default {
  name: 'WifiOops',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss">
 @import './../styles/_global.scss';
 @import './../styles/_variables.scss';
</style>
